import { useQuery } from "@tanstack/react-query";
import Select, { SelectProps } from "components/select";
import { rmOpListApi } from "components/api/comm";
import { IOpComm } from "interface/rm/op";
import i18n from "locales/i18n";
import { useRef } from "react";

interface IProps extends Omit<SelectProps, "options"> {
  select?(inf: any): void;
  isFullInf?: boolean;
  isReset?: boolean;
  rmNo: string;
}

export default function RmOpNmSelect({
  rmNo,
  isFullInf,
  isReset,
  required,
  select,
}: IProps) {
  const lng = i18n.language;
  const opRef = useRef<IOpComm[]>([]);

  useQuery({
    queryKey: ["rmOpList"],
    queryFn: () => {
      return rmOpListApi(rmNo);
    },
    select: (data: any) => {
      if (data) {
        opRef.current = data.data.rmOpList.map((op: IOpComm) => {
          return {
            ...op,
            ko: lng === "ko" ? op.rmOpNm : "",
            en: lng === "en" ? op.rmOpNm : "",
            value: op.rgSeq,
            code: op.rgSeq,
          };
        });
      }
    },
    enabled: !!rmNo,
  });

  return (
    <>
      <Select
        name={"rgSeq"}
        styles="bg-white border-1"
        options={opRef.current}
        required={required}
        validateTxt="객실옵션을 선택하여 주세요."
        isReset={isReset}
        onSelect={(option: any) => {
          if (select) {
            isFullInf ? select(option) : select(option.rgSeq);
          }
        }}
      />
    </>
  );
}
